import { useEffect, useState } from "react";
import { BridgeStatus, api, isError } from "../api";

/** Polls /bridge/status every 2s. Bridge state is the one thing every
 * page cares about (we render its badge in the global top strip), so we
 * lift it out of per-page hooks. */
export function useBridgePoll(intervalMs = 2000): BridgeStatus | null {
  const [bridge, setBridge] = useState<BridgeStatus | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function tick() {
      const b = await api.bridgeStatus();
      if (cancelled) return;
      setBridge(isError(b) ? { connected: false } : b);
    }
    void tick();
    const id = setInterval(tick, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [intervalMs]);

  return bridge;
}
